import angular from 'angular';
import template from './intro.component.html';
import './intro.repository.js';
import citaImpar from '../../assets/images/testimonios/cita-impar.svg'
import citaPar from '../../assets/images/testimonios/cita-par.svg'



angular
    .module('Toke')
    .component('appIntro', {
        template,
        bindings: {
            data: '<'
        },
        controller: IntroController
    });

IntroController.$inject = ['introRepository'];

function IntroController(introRepository) {
    const vm = this;

    vm.introData = {};

    this.citaImpar = citaImpar
    this.citaPar = citaPar

    vm.$onInit = function () {


        if (vm.data) {
            vm.introData = vm.data;

        } else {
            introRepository.getIntro().then(res => {
                vm.introData = res;

            });
        }
    };
}